import React, {Component} from 'react';
import CustomForm from "../../../shared/components/form/CustomForm";
import {RemedialTrainingFieldCofig} from "../../../shared/components/form/FormFieldsConfig";

class RemedialTrainingFieldFormCard extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  render() {
    return (
      <CustomForm
        config={RemedialTrainingFieldCofig}
        onSubmit={(form) => this.props.onSave(form)}
        isLoading={this.props.isLoading}
        initialValues={this.props.initialValues}
      />
    )
  }

}

export default RemedialTrainingFieldFormCard;
